import React from "react";
import { MenuItem } from "react-pro-sidebar";
import { Link, useLocation } from "react-router-dom";

export const SidebarItem = ({ collapsed, icon, text, link }) => {
  const location = useLocation();
  const isActive = location.pathname === link;

  return (
    <MenuItem
      component={<Link to={link} />}
      active={isActive}
    >
      <div className={`flex items-center gap-4 ${collapsed ? 'justify-center' : 'pl-3'}`}>
        <div className="flex-shrink-0">{icon}</div>
        {!collapsed && <span className="font-medium text-sm font-nunito">{text}</span>}
      </div>
    </MenuItem>
  );
};